import fetchService from './fetchService';
import axios from './axiosService';

export default {
  /**
   * MLD-7625
   * @returns {Promise<Array>}
   */
  async getSharedLinksForCurrentUser(chunkSize = 100, concurrentRequests = 4) {
    const params = {}
    return await fetchService.fetchRecords('/api/user/shared-links', params, chunkSize, concurrentRequests);
  },
}
